(function ($) {
    /**
     * Get proper declension of word "miesiąc" (month) based on number
     */
    function getMonthsWord(months) {
        months = parseInt(months);
        if (months === 1) {
            return 'miesiąc';
        }

        if (months >= 2 && months <= 4) {
            return 'miesiące';
        }

        return 'miesięcy';
    }

    function formatPrice(price) {
        price = (Number.isInteger(price)) ? price : price.toFixed(2);
        return price.toString().replace('.', ',');
    }

    // Variant click handler (shared duration selector)
    $('.offer-30-subscription-multiple .offer-30__select.variant li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const variant_id = $(this).data('variant');
        const show_price_per_month = $(this).parents('.offer-30').data('show-prices-per-month');
        const show_promo_prices = $(this).parents('.offer-30').data('show-promo-prices');
        const show_reference_price = $(this).parents('.offer-30').data('show-reference-price');
        const actual_variant_length = parseInt($(this).data('variant-length'));
        const variant_length = (show_price_per_month) ? actual_variant_length : 1;
        const variant_show_price_day = $(this).data('variant-show-price-day');
        const variant_title = $(this).find('.variant-title').text();
        const cart_url = $(this).parents('.offer-30').data('cart-url');

        $('.offer-30-subscription-multiple .offer-30_column').each(function () {
            const variants = $(this).data('variants');
            const $price_month = $(this).find('.prices .price-month strong');
            const $price_month_del = $(this).find('.prices .price-month del');
            const $price_for_day = $(this).find('.price_for_day');
            const $price_for_x_months = $(this).find('.price_for_x_months');

            // Price per month = variant price / variant_length
            const price_per_month = Math.round(variants[variant_id]['price'] / variant_length);
            $price_month.text(formatPrice(price_per_month));

            // Del: promo price only with show_promo_prices, 1-month reference only with show_price_per_month
            const variant_regular = Math.round(variants[variant_id]['display_regular_price'] / variant_length);
            const is_on_sale = variants[variant_id]['display_regular_price'] > variants[variant_id]['price'];

            let show_del = false;
            let del_price = variant_regular;
            if (show_reference_price && show_price_per_month) {
                const one_month_price = Math.round(variants[0]['price']);
                if (one_month_price > price_per_month) {
                    show_del = true;
                    del_price = one_month_price;
                }
            }
            if (!show_del && show_promo_prices && is_on_sale) {
                show_del = true;
            }
            $price_month_del.text(del_price);

            if (show_del) {
                $price_month_del.show();
            } else {
                $price_month_del.hide();
            }

            // Price for X months (total subscription price)
            if (show_price_per_month && actual_variant_length > 1) {
                const total_price = formatPrice(variants[variant_id]['price']);
                const total_regular = formatPrice(variants[variant_id]['display_regular_price']);
                const variant_on_sale = variants[variant_id]['display_regular_price'] > variants[variant_id]['price'];

                if (show_promo_prices && variant_on_sale) {
                    $price_for_x_months.html('<del>' + total_regular + '</del> ' + total_price + ' zł za ' + actual_variant_length + ' mies.');
                } else {
                    $price_for_x_months.text(total_price + ' zł za ' + actual_variant_length + ' mies.');
                }
                $price_for_x_months.show();
            } else {
                $price_for_x_months.hide();
            }

            // Price for day text
            if (variant_show_price_day) {
                $price_for_day.show();
                const length_divider = (actual_variant_length % 12 === 0) ? actual_variant_length / 12 * 365 : actual_variant_length * 31;
                const price_for_day_val = (variants[variant_id]['price'] / length_divider).toFixed(2);
                const months_word = getMonthsWord(actual_variant_length);
                $price_for_day.html('<strong>' + formatPrice(parseFloat(price_for_day_val)) + ' zł za 1 dzień</strong> korzystania z platformy. Automatycznie odnowimy pakiet co ' + actual_variant_length + ' ' + months_word + '. Przerwij w dowolnym momencie.');
            } else {
                $price_for_day.hide();
            }

            // Calculate savings: (1-month price * actual_length) - current variant price
            const savings_raw = variants[0]['price'] * actual_variant_length - variants[variant_id]['price'];
            const savings = formatPrice(savings_raw);
            const $package_savings = $(this).find('.package_savings');
            const savings_prototype = $package_savings.data('prototype');

            if (savings_prototype) {
                const savings_copy = savings_prototype.replace('%s', savings);
                $package_savings.text(savings_copy);
            }

            if (savings_raw <= 0) {
                $package_savings.html('&nbsp;');
            }

            // Update add-to-cart link and GTM data
            const $add_to_cart = $(this).find('.product a');
            const $gtm4wp_data = $(this).find('.gtm4wp_productdata');
            const variants_gtm4wp_data = $(this).data('gtm4wp-data');

            $add_to_cart.attr('href', cart_url + '?add-to-cart=' + variants[variant_id]['variation_id']);
            $add_to_cart.attr('data-product_id', variants[variant_id]['variation_id']);
            if (variants_gtm4wp_data && variants_gtm4wp_data[variant_id]) {
                $gtm4wp_data.attr('data-gtm4wp_product_data', variants_gtm4wp_data[variant_id]);
            }

            // Update omnibus (equalizeColumnHeights called after loop)
            const $omnibus = $(this).find('.omnibus');
            $omnibus.html(variants[variant_id]['omnibus_msg']);

            // Update property visibility (show_on)
            const $properties = $(this).find('.property');
            $properties.each(function () {
                const showOn = $(this).data('showOn');
                if (!showOn || !showOn.includes(variant_id.toString())) {
                    $(this).addClass('hidden');
                } else {
                    $(this).removeClass('hidden');
                }
            });
        });

        // Hide all savings if none have content
        const $allSavings = $('.offer-30-subscription-multiple .package_savings');
        const hasAnySavings = $allSavings.filter(function () {
            return $(this).text().trim().length > 0 && $(this).html() !== '&nbsp;';
        }).length > 0;

        if (hasAnySavings) {
            $allSavings.show();
        } else {
            $allSavings.hide();
        }

        equalizeColumnHeights();
    });

    // Package selector (mobile)
    $('.offer-30-subscription-multiple .offer-30__select.package li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const package_id = $(this).data('packageId');

        $('.offer-30-subscription-multiple .offer-30_column').each(function () {
            if ($(this).data('package') === package_id - 1) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
    });

    // Sticky header for package selector
    document.querySelectorAll('.offer-30-subscription-multiple .package-select-wrapper').forEach(function (elem) {
        new IntersectionObserver(function (entries) {
            for (const entry of entries) {
                entry.target.classList.toggle('stuck', !entry.isIntersecting);
            }
        }, {
            rootMargin: '-' + (parseInt(window.getComputedStyle(elem).getPropertyValue('top')) + 1) + 'px 0px',
            threshold: 1,
        }).observe(elem);
    });

    // Equalize column heights so prices and CTAs align across packages.
    function equalizeColumnHeights() {
        const $block = $('.offer-30-subscription-multiple');
        const $subheadings = $block.find('.offer-30_column-top .subheading');
        const $prices = $block.find('.offer-30_column-top .prices');

        $subheadings.css('min-height', '');
        $prices.css('min-height', '');

        let maxSubheading = 0;
        $subheadings.each(function () {
            const h = $(this).innerHeight();
            if (h > maxSubheading) maxSubheading = h;
        });
        $subheadings.css('min-height', maxSubheading);

        let maxPrices = 0;
        $prices.each(function () {
            const h = $(this).innerHeight();
            if (h > maxPrices) maxPrices = h;
        });
        $prices.css('min-height', maxPrices);
    }

    $(document).ready(equalizeColumnHeights);
    $(window).on('resize', equalizeColumnHeights);

    // Tooltip/modal handlers
    $('body').on('click', function (e) {
        if ($(e.target).parents().hasClass('property')
            || $(e.target).hasClass('property')
            || $(e.target).parents().hasClass('property_group')
            || $(e.target).hasClass('property_group')) {
            e.stopPropagation();
            return;
        }
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
    });

    $(document).on("keydown", (event) => {
        if (event.key === "Escape" || event.keyCode === 27) {
            closeModal();
        }
    });

    $('#offer-30-video-modal .modal-close').on('click', closeModal);

    $('#offer-30-video-modal .modal-wrapper').on('click', () => {
        closeModal();
    });

    $('#offer-30-video-modal .modal').on('click', (e) => {
        e.stopPropagation();
    });

    function closeModal() {
        $('#offer-30-video-modal video')[0]?.pause();
        $('#offer-30-video-modal').fadeOut(300);
        $('body').css('overflow', 'auto');
    }

    $('.offer-30-subscription-multiple .property, .offer-30-subscription-multiple .property-group-heading').on('click', function (e) {
        openTooltip($(this).find('.tooltip'), e);
    });

    if (window.innerWidth > 992) {
        $('.offer-30-subscription-multiple .property, .offer-30-subscription-multiple .property-group-heading').on('mouseover', function (e) {
            openTooltip($(this).find('.tooltip'), e);
        });
    }

    $('.offer-30-subscription-multiple .property, .offer-30-subscription-multiple .property-group-heading').on('mouseout', function (event) {
        var e = event.toElement || event.relatedTarget;
        if ($(e).hasClass('tooltip-open') || $(e).parents().hasClass('tooltip-open')) {
            return;
        }

        $('.tooltip').removeClass('open');
        $('.tooltip-open').remove();
    });

    function openTooltip($tt, event) {
        if (event.type === 'click' && $(event.target).hasClass('play-icon') && $tt.hasClass('open')) {
            $('.tooltip-video').trigger('click');
            return;
        }

        if ($tt.hasClass('open')) return;
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
        $tt.addClass('open');

        const ID = $tt.parent().data('id');
        const tooltip_content = $tt.data('tooltip-content');
        const tooltip_video = $tt.data('video');
        const $tooltip = $(`${tooltip_content}`);
        $tt.append($tooltip);
        $tooltip.attr('data-id', ID);

        let offset = $tooltip.offset();
        if (offset) {
            $tooltip.appendTo("body")
                .css({
                    position: "absolute",
                    top: offset.top,
                    left: offset.left,
                    translate: 'unset',
                });
        }

        $tooltip.find('.tooltip-video').on('click', function () {
            $('#offer-30-video-modal video').attr('src', tooltip_video).attr('controls', 'controls');
            $('#offer-30-video-modal video')[0].play();
            $('#offer-30-video-modal').fadeIn(300);
            $('body').css('overflow', 'hidden');
            $('.tooltip-open').remove();
            $tt.removeClass('open');
        });
    }

})(jQuery);
